import React from "react";
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js'
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import ConfigContext from "../contexts/configContext";

let reactPlugin: any = null;
let appInsights: any = null;

const createTelemetryService = (isActive: boolean) => {

    const initialize = (instrumentationKey: string) => {

        if (!instrumentationKey) {
            throw new Error('Instrumentation key not provided.')
        }

        reactPlugin = new ReactPlugin();

        appInsights = new ApplicationInsights({
            config: {
                instrumentationKey: instrumentationKey,
                maxBatchInterval: 0,
                disableFetchTracking: false,
                extensions: [reactPlugin],
                isCookieUseDisabled: isActive
            }
        });
    };

    return { reactPlugin, appInsights, initialize };
};

export const ai = (isActive: boolean ) => createTelemetryService(isActive);
export const getAppInsights = () => appInsights;

export const trackEvent = (event: any) => appInsights?.trackEvent(event);

interface IProps {
    onError: any
    children: any
    isActive: boolean
}
interface IState {
    initialized: boolean
    appInsightsInstrumentationKey: string
    hasError: boolean
    isAiAttached: boolean
}

class AppInsightsErrorBoundary extends React.Component<IProps, IState> {
    constructor(props: any) {
        super(props)
        this.state = { hasError: false, initialized: false, appInsightsInstrumentationKey: "", isAiAttached: false}
    }

    async initializeApplicationInsights() {
        let config = this.context;

        const { initialized } = this.state;
        this.setState({ appInsightsInstrumentationKey: config.azStoreConfig.appinsights_Instrumentationkey });

        if (!initialized && this.state.appInsightsInstrumentationKey) {
            ai(this.props.isActive).initialize(this.state.appInsightsInstrumentationKey)
            this.setState({ initialized: true })
        }

        if(this.state.initialized && this.props.isActive){
            appInsights.loadAppInsights();
            appInsights.trackPageView();

            this.setState({ isAiAttached: true});
        }
    }

    async componentDidMount() {
        let config = this.context;

        config.azStoreConfig &&
            await this.initializeApplicationInsights();
    }

    async componentDidUpdate() {
        if(!this.state.initialized) {

            let config = this.context;

            config.azStoreConfig &&
                await this.initializeApplicationInsights();
        } 
        
        if(!this.state.isAiAttached && this.props.isActive){
            appInsights.loadAppInsights();
            appInsights.trackPageView();

            this.setState({ isAiAttached: true});
        }
    }

    async componentDidCatch(error: any, errorInfo: any) {

        await this.initializeApplicationInsights();

        this.setState({ hasError: true })
        if (this.props.isActive) {
            getAppInsights().appInsights.trackException({
                error,
                exception: error,
                severityLevel: SeverityLevel.Error,
                properties: { ...errorInfo },
            })
        }
    }

    render() {
        const { hasError } = this.state
        const { onError, children } = this.props
        if (hasError) {
            return typeof onError === 'function'
                ? onError()
                : React.createElement(onError)
        }

        return children
    }
}

AppInsightsErrorBoundary.contextType = ConfigContext;

export default AppInsightsErrorBoundary 